import { DissertacoesProps } from '@/@types/PosGraduacao/ListaDissertacoesTeses';
import DissertacaoItem from './DissertacaoItem';



const DissertacoesTesesAgendas = ({ dissertacoes }: DissertacoesProps) => {

    return (
        <div className='flex flex-wrap space-x-[15px]'>
            {
                dissertacoes?.map(dissertacao => {
                    return (
                        <DissertacaoItem key={dissertacao._id} dissertacao={dissertacao} />
                    )
                })
            }
        </div>
    )
}

export default DissertacoesTesesAgendas;